type Props = {
  size?: number;
  withWordmark?: boolean;
  className?: string;
};

/**
 * MatchRite mark — network-driehoek.
 * Indigo node bovenaan (MatchRite als hub) verbindt
 * groen (monteur/eigen) en amber (opdrachtgever/algemeen).
 * Twee-kleurige edges lopen van node naar node.
 */
export default function Logo({
  size = 24,
  withWordmark = true,
  className = "",
}: Props) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 28 28"
        fill="none"
        aria-label="MatchRite"
      >
        {/* ── Edges: twee segmenten per zijde, kleur loopt van node naar node ── */}

        {/* Links: indigo (boven) → groen (onder-links) */}
        <line x1="12"  y1="7.5" x2="9"  y2="13"   stroke="#4A5BD9" strokeWidth="2"   strokeLinecap="round" strokeOpacity="0.55" />
        <line x1="9"   y1="13"  x2="6"  y2="18.5"  stroke="#14C07A" strokeWidth="2"   strokeLinecap="round" strokeOpacity="0.55" />

        {/* Rechts: indigo (boven) → amber (onder-rechts) */}
        <line x1="16"  y1="7.5" x2="19" y2="13"   stroke="#4A5BD9" strokeWidth="2"   strokeLinecap="round" strokeOpacity="0.55" />
        <line x1="19"  y1="13"  x2="22" y2="18.5"  stroke="#E3852A" strokeWidth="2"   strokeLinecap="round" strokeOpacity="0.55" />

        {/* Onder: groen (links) → amber (rechts) */}
        <line x1="8"   y1="22"  x2="14" y2="22"   stroke="#14C07A" strokeWidth="2"   strokeLinecap="round" strokeOpacity="0.55" />
        <line x1="14"  y1="22"  x2="20" y2="22"   stroke="#E3852A" strokeWidth="2"   strokeLinecap="round" strokeOpacity="0.55" />

        {/* ── Nodes ── */}
        <circle cx="14" cy="4"  r="4.2" fill="#4A5BD9" />  {/* indigo — hub */}
        <circle cx="4"  cy="22" r="4.2" fill="#14C07A" />  {/* groen  — monteur */}
        <circle cx="24" cy="22" r="4.2" fill="#E3852A" />  {/* amber  — opdrachtgever */}
      </svg>

      {withWordmark && (
        <span
          className="font-extrabold uppercase"
          style={{ fontSize: size * 0.95, lineHeight: 1, letterSpacing: "0.04em" }}
        >
          <span style={{ color: "#0B0E0C" }}>Match</span>
          <span style={{ color: "#6e7470" }}>Rite</span>
        </span>
      )}
    </span>
  );
}
